import axiosPost from '../axiosPost';

export const registrosDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "RegistroDel",
        "params": { "registroId": id }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}